import * as React from 'react';

export default class Page404 extends React.Component {
  render() {
    return (
      <div className="w-1/2 my-48 mx-auto text-xl text-center">
        <h1 className="mb-2 text-6xl text-red">404</h1>
        <p>This page does not exist</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/404.tsx